<template>
  <div :class="{'disableUpload':disableUpload}">
    <Upload
      action
      list-type="picture-card"
      :file-list="getAttachments"
      :limit="maxAllowed"
      :auto-upload="false"
      :multiple="multiple"
      :on-exceed="handleExceed"
      :on-change="multiple ? addAttachments : addAttachment"
      :disabled="disableUpload"
      class= "default-upload flex-reverse is-badge"
      :class="{'is-disabled':disableUpload,
                'list-tags':  isGatePassDocument,
      }"
    >
      <i class="el-icon-plus"></i>
      <div class="el-upload-list__item-slot" slot="file" slot-scope="{file}" v-if="file.index === 0">
        <img class="el-upload-list__item-thumbnail" :src="setIcon(file)" alt="" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="openPreviewDialog()">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="badge" v-if="attachmentsCountBadge">+{{attachmentsCountBadge}}</span>
        </span>
        <span v-if ="isGatePassDocument" class="file-name">{{ file.name.slice(0, 16) + '...' }} </span>
      </div>
    </Upload>
    <a class="download-file" />
    <!-- start of dialog for attachment preview -->
    <Dialog
      :visible.sync="viewAttachmentsDetailsSlider"
      width="80%"
      :append-to-body="true"
      :fullscreen="true"
      :show-close="false"
      custom-class="preview-popup"
    >
      <div class="preview-header text-right">
        <span class="actions" style="margin-right: 20px;">
          <span v-if="dialogVisible"> 
          <svgicon
          name="rotate-left"
          class="pointer"
          width="20"
          height="20" 
          @click="rotateLeft" />
           <svgicon
          name="rotate-right"
          class="pointer ml-20"
          width="20"
          height="20"
          @click="rotateRight" />
          </span>
          <svgicon 
            name="icon-expand-xl"
            class="pointer ml-20"
            width="20"
            height="20"
            @click="handlePictureCardPreview(selectedAttachment)" />
          <svgicon
            name="icon-download-xl"
            class="pointer ml-20"
            width="20"
            height="20"
            @click="handleDownload(selectedAttachment)" />
          <svgicon
          v-if="this.allowDelete"
            name="icon-delete-md"
            class="pointer ml-20"
            width="20"
            height="20"
            @click="removeAttachment(selectedAttachment)" />
          <svgicon
            name="cancelnocolor"
            class="pointer ml-20"
            width="20"
            height="20"
            @click="viewAttachmentsDetailsSlider = false" />
        </span>
      </div>
      <div class="preview-body">
        <div class="preview-img" v-if="!dialogVisible">
          <span class="file-name" v-if="selectedAttachment">
            {{ selectedAttachment.name }}
          </span>
          <img :src="selectedImageSrc" alt="" />
        </div>
        <Upload
        v-if="!dialogVisible"
          action
          list-type="picture-card"
          :file-list="getAttachments"
          :limit="5"
          :auto-upload="false"
          :on-exceed="handleExceed"
          :on-change="addAttachment"
          :disabled="disableUpload"
          class="default-upload preview-thumbnail is-disabled"
        >
          <div class="el-upload-list__item-slot" slot="file" slot-scope="{file}">
            <img class="el-upload-list__item-thumbnail" :src="setIcon(file)" alt="" />
            <span class="el-upload-list-actions" @click="previewAttachment(file)"></span>
          </div>
        </Upload>
        <a class="download-file" />
        <Dialog 
        :visible.sync="dialogVisible" :modal="false" :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out`">
          <img width="100%" :src="selectedImageSrc" alt=""/>
        </Dialog>
      </div>
    </Dialog>
    <!-- end of dialog for attachment preview -->
  </div>
</template>
<script type="text/javascript">
import AttachmentConstants from "@common/constants/AttachmentConstants";
import UploadMixin from "@common/mixins/UploadMixin";
export default {
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    disableUpload: {
      type: Boolean,
      default: false
    },
    maxAllowed: {
      type: Number,
      default: 5
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    allowDelete: {
       type: Boolean,
      default: false,
    },
    isGatePassDocument: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      viewAttachmentsDetailsSlider: false,
    };
  },
  mixins: [UploadMixin],
  created() {
    this.selectedAttachmentIndex = 0;
  },
  computed: {
    hasAttachments() {
      return this.attachments && this.attachments.length;
    },
    getAttachments() {
      return (
        this.attachments &&
        this.attachments.map((val, index) => {
          return Object.assign(val, { index });
        })
      );
    },
    attachmentsCountBadge() {
      return this.attachments && this.attachments.length > 1
        ? this.attachments.length - 1
        : 0;
    }
  },
  methods: {
    openPreviewDialog() {
      this.viewAttachmentsDetailsSlider = true;
    },
    addAttachments(file, fileList) {
      this.addAttachment(file, fileList);
    },
    removeAttachment(file) {
      this.$emit('removeAttachments', file);
      this.selectedAttachmentIndex = 0;
      if (this.hasAttachments <= 1) {
        this.viewAttachmentsDetailsSlider = false;
      }
    },
  }
};
</script>
